import { deserializeSuperjson } from '@lib/superjson';
import type {
  ViewSnapSiteConfigRequest,
  ViewSnapSiteConfigResponse,
} from '@snap-types/actions/view-snap-site-config';
import {
  enhanceEndpoints,
  injectEndpoints,
} from '@ui/store/api-builder/inject-mutation';

const injectedApi = injectEndpoints({
  endpoints: (builder) => ({
    viewSnapSiteConfig: builder.query<
      ViewSnapSiteConfigResponse,
      ViewSnapSiteConfigRequest
    >({
      transformResponse: deserializeSuperjson,
      query: ({ siteCode, snapSiteConfigUuid }) => ({
        url: `/admin/sites/${siteCode.toLowerCase()}/snap-site-config/${snapSiteConfigUuid}`,
      }),
      providesTags: (_result, _error, args) => [
        { type: 'EditSnapSiteConfig', id: args.snapSiteConfigUuid },
      ],
    }),
  }),
});

enhanceEndpoints({
  addTagTypes: ['EditSnapSiteConfig'],
});

declare module '@ui/store/data' {
  interface ApiTagTypesMap {
    EditSnapSiteConfig: 'EditSnapSiteConfig';
  }
}

export const viewSnapSiteConfig = injectedApi.endpoints.viewSnapSiteConfig;
export const useViewSnapSiteConfigQuery = viewSnapSiteConfig.useQuery;
